var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classnames from 'classnames';
export const Link = (_a) => {
    var { className, color, negative, primary, subdued, disabled } = _a, props = __rest(_a, ["className", "color", "negative", "primary", "subdued", "disabled"]);
    const LinkElement = props.href ? 'a' : 'button';
    const LinkClasses = classnames('Link', className, {
        'Link--blue': primary || color === 'blue' || color === 'primary',
        'Link--red': negative || color === 'red' || color === 'negative',
        'Link--grey': subdued || color === 'grey' || color === 'subdued',
        'Link--disabled': disabled,
    });
    return (React.createElement(LinkElement, Object.assign({ role: "link", className: LinkClasses, "data-anvil-component": "Link" }, props), props.children));
};
//# sourceMappingURL=Link.js.map